// extracted by mini-css-extract-plugin
export default {"successColor":"#4cbf8f","failedColor":"#f66","moderationColor":"#ffac30","headerHeight":"68px","spinnerHeight":"60px","spinnerWidth":"100px","arrow":"Arrow_arrow__MOUtu"};